module.exports = __webpack_public_path__ + "img/1_Dicks_Screen_2_R.42eaa2a5.jpg";